export const formatTextMaxChars = (text: string, maxChars: number)=> {
  if (!text) return '';
  if (text.length > maxChars) {
    return text.slice(0, maxChars) + "...";
  }
  return text;
}
